import { Box, Heading, Text, VStack } from "@chakra-ui/react"
import { useContext } from "react"
import { ThemeContext } from "../context/ThemeContext"
import { LanguageContext } from "../context/LanguageContext"
import LazyItem from "./LazyItem"
import { faJs, faReact, faNodeJs, faGitAlt, faPython, faDocker} from "@fortawesome/free-brands-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faDatabase, faMicrochip, faCloud, faServer, faRobot, faNetworkWired, faCode, faCogs } from "@fortawesome/free-solid-svg-icons"

const Perfil = () => {

    const { t } = useContext(LanguageContext)

    const skills = [
        {
            skillName: "JavaScript",
            icon: faJs
        },
        {
            skillName: "React",
            icon: faReact
        },
        {
            skillName: "Node.js",
            icon: faNodeJs
        },
        {
            skillName: "Python",
            icon: faPython
        },
        {
            skillName: "PostgreSQL",
            icon: faDatabase
        },
        {
            skillName: "Docker",
            icon: faDocker
        },
        {
            skillName: "ESP32/IoT",
            icon: faMicrochip
        },
        {
            skillName: "Cloud",
            icon: faCloud
        },
        {
            skillName: "DevOps",
            icon: faServer
        },
        {
            skillName: "IA/ML",
            icon: faRobot
        },
        {
            skillName: "N8n",
            icon: faNetworkWired
        },
        {
            skillName: "C/C++",
            icon: faCode
        },
        {
            skillName: "PLC",
            icon: faCogs
        },
        {
            skillName: "Git",
            icon: faGitAlt
        }
    ]

    const {theme} = useContext(ThemeContext)
    
    return (
        <Box
            background={theme.bg.perfil}
            transitionProperty="background" 
            transitionDuration="0.3s"
            id="perfil"
        >
                <VStack>
                    <Heading
                        as="h1"
                        fontSize="50px"
                        padding="5rem 0 2rem 0"
                    >
                        {t('profile.title')}
                    </Heading>
                    <Box
                        display='flex'
                        justifyContent='center'
                    >
                        <Text 
                            fontSize="1.6rem"
                            width='90%'
                            textAlign='center'
                        >
                            {t('profile.description')}
                        </Text>
                    </Box>
                    <Box>
                        <Heading
                            as="h4"
                            textAlign='center'
                            padding='5rem 0 2rem 0'
                            fontSize='2.5rem'
                        >
                            {t('profile.skills')}
                        </Heading>
                        <Box
                            display='flex'
                            justifyContent='center'
                            alignItems='center'
                            width="100%"
                        >
                            <Box
                                className="skills-container"
                            >
                                {
                                    skills.map((skill, index)=>(
                                        <LazyItem key={skill.skillName} index={index} delay={0.3}>
                                            <Box
                                                display="flex"
                                                flexDirection='column'
                                                border="solid 2px #000"
                                                borderRadius="1rem"
                                                alignItems="center"
                                                justifyContent='center'
                                                padding="1rem"
                                                boxShadow="0 4px 8px rgba(0, 0, 0, 0.1)"
                                                transition="all 0.3s ease"
                                                _hover={{
                                                    boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
                                                    transform: "translateY(-4px)"
                                                }}
                                            >
                                                <Box
                                                    display="flex"
                                                    alignItems="center"
                                                    justifyContent="center"
                                                >
                                                    <FontAwesomeIcon fontSize='2rem' icon={skill.icon} />
                                                </Box>
                                                <Heading as="h5" fontSize="1.3rem">{skill.skillName}</Heading>
                                            </Box>
                                        </LazyItem>
                                    ))
                                }
                            </Box>
                        </Box>
                    </Box>
                </VStack>
        </Box>
    )
}

export default Perfil